import { DialogContent, DialogHeader, DialogRoot, DialogTitle, ScrollArea } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SCROLL_AREA_VIEWPORT_BLOCK } from '@/shared/lib';
import { RuleInfoSections } from './RuleInfoSections';

type Props = {
  onClose: () => void;
};

/**
 * Справка по синтаксису правила извлечения на узком экране — обычное окно системы.
 * Перетаскивание и изменение размера углом на телефоне недоступны, поэтому окно
 * открывается в границах экрана и закрывается штатными приёмами.
 */
export const RuleInfoDialog: FC<Props> = ({ onClose }) => {
  const { t } = useTranslation('attributes');

  return (
    <DialogRoot open onOpenChange={(open) => !open && onClose()}>
      {/* Высота считается по видимой части экрана: на телефоне её занижает адресная строка браузера */}
      <DialogContent className="max-h-[calc(100dvh_-_2rem)] grid-rows-[auto_minmax(0,1fr)] overflow-hidden">
        <DialogHeader>
          <DialogTitle>{t('ruleInfo.title')}</DialogTitle>
        </DialogHeader>
        <ScrollArea orientation="vertical" className={SCROLL_AREA_VIEWPORT_BLOCK}>
          <RuleInfoSections />
        </ScrollArea>
      </DialogContent>
    </DialogRoot>
  );
};
